import request from '../utils/request.js'
//绑定手机号
export function checkOrderNumber(data) {
  let url = "";
  if(data.code != undefined){
    url = process.env.API + "/order/rest/bindThirdOrderMobile?orderId="+data.orderId+"&mobile="+data.mobile+"&code="+data.code;
  }else{
    url = process.env.API + "/order/rest/bindThirdOrderMobile?orderId="+data.orderId+"&mobile="+data.mobile
  }
  return request({
    url: url,
    method: 'post'
  })
}

//获取验证码
export function getMobileCode(data) {
  return request({
    url: process.env.MYURL + "/login/getMobileCode?mobile=" + data.mobile,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/bindMobileNumber.js